import { getDateInFormat } from "@domains/utils/reportDates";
export var partnerProfDemMetNomSegMapper = function (data) {
    var _a;
    var partnerData = data.data && ((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.length) > 0
        ? data.data[0]
        : {};
    var profileData = {
        upc: partnerData.upc,
        partnerCode: partnerData.partner_code,
        partnerCreatedDate: partnerData.created_date
            ? getDateInFormat(partnerData.created_date, "DD MMM YY")
            : "",
        partnerType: partnerData.partner_type,
        partnerName: partnerData.partner_name,
        branchId: partnerData.branch_code,
        acquiringRMCode: partnerData.frm_code,
        partnerOwner: partnerData.frm_code,
        ownerMappingDate: partnerData.frm_mapping_date
            ? getDateInFormat(partnerData.frm_mapping_date, "DD MMM YY")
            : "",
        agreementType: partnerData.agreement_type_name,
        partnerTier: "",
        partnerClub: "",
        frmName: partnerData.frm_name,
        acquirerName: partnerData.acquirer_name,
        acquirerLobName: partnerData.acquirer_lob_name,
        lobName: partnerData.lob_name,
    };
    var demographicsDetails = {
        panNo: partnerData.pan_no,
        dob: partnerData.dob ? getDateInFormat(partnerData.dob, "DD MMM YY") : "",
        aadhaarNumber: partnerData.aadhar_no,
        communicationAddress: partnerData.primary_address1,
        state: partnerData.state_name,
        city: partnerData.city_name,
        country: "",
        pinCode: partnerData.pincode,
        businessContactRepresentative: "",
        mobile: partnerData.primary_mobile,
        emailId: partnerData.email_id,
        partnerStatus: partnerData.status,
        gstNo: partnerData.gst_no,
        gstR: partnerData.gst_arn_no,
    };
    var mappingDetails = {
        lob: partnerData.lob_name,
        subLob: partnerData.sublob_name,
    };
    var nomineeDetails = {
        guardianAadhar: partnerData.guardian_aadhar,
        guardianAddress: partnerData.guardian_address,
        guardianName: partnerData.guardian_name,
        guardianPan: partnerData.guardian_pan,
        nomineeName: partnerData.nominee_name,
        relationShipWithGuardian: partnerData.relationship,
    };
    var segmentDetails = {
        productActive: "",
    };
    var finalPartnerData = {
        profile: profileData,
        demographics: demographicsDetails,
        mapping: mappingDetails,
        nominee: nomineeDetails,
        segment: segmentDetails,
    };
    return finalPartnerData;
};
